import { render, staticRenderFns } from "./text-editor.vue?vue&type=template&id=36303680&"
import script from "./text-editor.vue?vue&type=script&lang=js&"
export * from "./text-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports